import React, { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { updatePassword } from "../../../features/user/userSlice";
import {
  isRequired,
  isValidPassword,
  passwordsMatch,
  PASSWORD_HINT,
} from "../../../utils/validation";

export default function PasswordChangeModal({ isOpen, onClose, idUser }) {
  const [form, setForm] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async () => {
    if (
      !isRequired(form.oldPassword) ||
      !isRequired(form.newPassword) ||
      !isRequired(form.confirmPassword)
    ) {
      toast.error("Bitte füllen Sie alle Felder aus.");
      return;
    }

    if (!isValidPassword(form.newPassword)) {
      toast.error(`Passwort: ${PASSWORD_HINT.toLowerCase()}.`);
      return;
    }

    if (!passwordsMatch(form.newPassword, form.confirmPassword)) {
      toast.error("Passwörter stimmen nicht überein");
      return;
    }

    setLoading(true);

    dispatch(
      updatePassword({
        id: idUser,
        oldPassword: form.oldPassword,
        newPassword: form.newPassword,
      }),
    )
      .unwrap()
      .then(() => {
        toast.success("Passwort erfolgreich geändert");
        onClose();
        setForm({
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
      })
      .catch((err) => {
        toast.error(err.message || "Fehler beim Ändern des Passworts");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-md">
          <h2 className="kn-h3 mb-4">Passwort ändern</h2>

          <div className="flex flex-col gap-4">
            <input
              type="password"
              name="oldPassword"
              placeholder="Aktuelles Passwort"
              className="inputStyle"
              value={form.oldPassword}
              onChange={handleChange}
            />
            <input
              type="password"
              name="newPassword"
              placeholder="Neues Passwort"
              className="inputStyle"
              value={form.newPassword}
              onChange={handleChange}
            />
            <input
              type="password"
              name="confirmPassword"
              placeholder="Neues Passwort wiederholen"
              className="inputStyle"
              value={form.confirmPassword}
              onChange={handleChange}
            />
            <p className="kn-small -mt-2">{PASSWORD_HINT}</p>
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <button onClick={onClose} className="kn-btn-ghost">
              Abbrechen
            </button>
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="kn-btn-primary"
            >
              {loading ? "Speichern..." : "Speichern"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
